import { render, staticRenderFns } from "./SummaryLikesAndReposts.vue?vue&type=template&id=6dafce76&"
import script from "./SummaryLikesAndReposts.vue?vue&type=script&lang=js&"
export * from "./SummaryLikesAndReposts.vue?vue&type=script&lang=js&"
import style0 from "./SummaryLikesAndReposts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports